/*
    Přidání štítku
*/
import React, { useState } from "react";
import translate from "../../Translations/index";
import { MAX_FILE_UPLOAD_SIZE, SERVER_URL, COUNTRY_IMAGE_URL } from "../../../Config";
import Notification from "../../../Library/notification";
import remove from "../../../Public/Images/remove.svg";
import { useMutation, useQuery } from "@apollo/client";
import { EDIT_COUNTRY_PHOTOS, GET_COUNTRY_PHOTOS } from "../Queries/country";

const EditCountryPhotos = (props) => {
    const [fileInputKey, setFileInputKey] = useState(0);
    const [formData, setFormData] = useState({
        countryID: props.countryID,
        flag: "",
        flagURL: "",
    });

    useQuery(GET_COUNTRY_PHOTOS, {
        variables: { countryID: formData.countryID },
        fetchPolicy: "cache-and-network",
        onCompleted(data) {
            setFormData({
                ...formData,
                flagURL: data.country.flag ? SERVER_URL + "/" + COUNTRY_IMAGE_URL + "/" + data.country.flag : "",
            });
        },
    });
    const [editCountryPhotos] = useMutation(EDIT_COUNTRY_PHOTOS, {
        onCompleted(data) {
            let notify = new Notification();
            notify.setNotification(translate.t("SuccessfullySaved"));
        },
        onError(err) {
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toStrng(), "danger");
        },
    });

    const openFlagFile = (e) => {
        var file = e.target.files[0];

        if (file) {
            var reader = new FileReader();
            reader.onload = (onLoadE) => {
                if (onLoadE.total / 1000000 <= MAX_FILE_UPLOAD_SIZE) {
                    setFormData({ ...formData, flagURL: reader.result, flag: file });
                } else {
                    let notify = new Notification();
                    notify.setNotification(translate.t("MaxFileSizeExceeded", { maxFileSize: MAX_FILE_UPLOAD_SIZE }), "danger");
                    setFileInputKey(fileInputKey + 1);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="form-group input-group">
                        <div className="form-group">
                            <label className="input-label">
                                {translate.t("CountryFlag")} (max {MAX_FILE_UPLOAD_SIZE}Mb)
                            </label>
                            {!formData.flagURL && !formData.flag ? (
                                <div className="custom-file">
                                    <input
                                        type="file"
                                        className="custom-file-input"
                                        id="customPhoto"
                                        name="flag"
                                        accept="image/*"
                                        onChange={(e) => openFlagFile(e)}
                                        key={fileInputKey}
                                    />
                                    <label className="custom-file-label" htmlFor="customPhoto">
                                        {translate.t("ChoosePhoto")}
                                    </label>
                                </div>
                            ) : (
                                <div>
                                    <div className="d-flex flex-column align-items-start">
                                        <img className="maxwidth-100 country-img" src={formData.flagURL} />
                                        <img
                                            onClick={() => setFormData({ ...formData, flag: "", flagURL: "" })}
                                            className="remove-icon mt-2"
                                            src={remove}
                                            title={translate.t("Remove")}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
                <button
                    type="button"
                    className="btn btn-primary mr-2"
                    onClick={() =>
                        editCountryPhotos({
                            variables: { ...formData },
                        })
                    }
                >
                    {translate.t("Edit")}
                </button>
                <button type="button" className="btn btn-danger" onClick={() => props.openCloseModal(false)}>
                    {translate.t("Close")}
                </button>
            </div>
        </>
    );
};

export default EditCountryPhotos;
